import { render, staticRenderFns } from "./SchedulePersonalContributionV2.vue?vue&type=template&id=53808344&scoped=true"
import script from "./SchedulePersonalContributionV2.vue?vue&type=script&lang=ts"
export * from "./SchedulePersonalContributionV2.vue?vue&type=script&lang=ts"
import style0 from "./SchedulePersonalContributionV2.vue?vue&type=style&index=0&id=53808344&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53808344",
  null
  
)

export default component.exports